export const metatagifront = {
  Page: {
    "meta-tagi": {
      Title:
        "All Inclusive ••• oferty all inclusive ••• TravelOne.pl",
      Description:
        "Wczasy All Inclusive - wybierając wakacje all inclsuive dostajesz wszystko w cenie ::: Turcja Grecja Egipt last minute all inclusive, luksusowe wczasy",
      Keywords: [],
    },
  },
};
